var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme.wrapper},[_c('div',{class:_vm.theme.left},[(_vm.config.buttons_location === 'bottom-left')?_c('app-button-control',{attrs:{"data":_vm.data}}):_c('app-page-size-control',{attrs:{"data":_vm.data}})],1),_vm._v(" "),_c('div',{class:_vm.theme.right},[_c('app-page-control',{ref:"pageControl",attrs:{"data":_vm.data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }